<div [hidden]="!showAIPromptEditor" cd2kDrag m22Res2izable class="box-shadow dialogwindow"
    style="padding: 1px 3px 10px 3px; height:100%; position: realtive; z-index: 999; width: 100%; left: 100px; border: 1px solid; color:black; border-radius: 2px; display: flex; flex-direction: column; min-height: 450px;">
    <div cdkDragHandle style="width:100%;background:rgb(88, 2, 101);height:24px;color:white;">
        <div style="float: left;padding: 2px 11px;font-size: 13px;">AI Agent</div>
        <div id="closebutton" style="padding: 0px 9px;float:right;cursor:pointer;" (click)="closeAIPromptEditor.emit()">
            <i class="fa-solid fa-xmark"></i>
        </div>
    </div>
    <div style="position: absolute; top: 25px; right: 40px; display: flex; align-items: center; gap: 10px;">

        <!-- <button mat-mini-fab color="primary" (click)="addTab()"
            style="position: absolute; z-index: 9999; top: 25px; right: 5px; width: 30px; height: 30px; min-height: 0; line-height: 30px;">
            <i class="fa-solid fa-plus" style="font-size: 12px;"></i>
        </button> -->
        <!-- <mat-form-field style="width: 100px; margin-right: 10px;z-index: 9999;">
            <mat-select [(ngModel)]="aiProvider">
                <mat-option value="claude" matTooltip="Use Claude AI">
                    <i class="fa-solid fa-robot"></i> Claude
                </mat-option>
                <mat-option value="openai" matTooltip="Use OpenAI">
                    <i class="fa-solid fa-brain"></i> OpenAI
                </mat-option>
                <mat-option value="gemini" matTooltip="Use Gemini">
                    <i class="fa-solid fa-microchip"></i> Gemini
                </mat-option>
                <mat-option value="deepseek" matTooltip="Use DeepSeek">
                    <i class="fa-solid fa-atom"></i> DeepSeek
                </mat-option>
            </mat-select>
        </mat-form-field> -->

        <!-- <mat-slider min="0" max="1" step="0.1" style="width: 100px;" [style.display]="aiProvider === 'openai' ? 'block' : 'none'">
            <input matSliderThumb [(ngModel)]="temperature" matTooltip="Temperature">
        </mat-slider> -->




    </div>
    <!-- <mat-tab-group class="no-animation" [selectedIndex]="currentTabId" (selectedIndexChange)="onTabChange($event)"
        [@.disabled]="true" style="flex: 1 1 auto; min-height: 0; display: flex; flex-direction: column;">

        <mat-tab *ngFor="let tab of tabs" [label]="'Sheet ' + tab.id">
            <ng-template mat-tab-label>
                <div class="tab-label-container" [ngClass]="{'processing-tab': isTabProcessing(tab.id)}">
                    <span style="color: white;">Sheet {{ tab.id+1 }}</span>
                    <span *ngIf="isTabProcessing(tab.id)" class="processing-indicator">
                        <i class="fa-solid fa-circle-notch fa-spin"></i>
                    </span>
                </div>
            </ng-template>
            <div class="tabpage"> -->


    <!-- Main chat history container -->
    <div #chatHistoryContainer class="chat-history" style="margin-bottom: 15px; overflow-y: auto; border: 1px solid #ddd; border-radius: 4px; padding: 10px;">
        <!-- Loop through component's chatHistory - Now directly reference project.chatHistory -->
        <!-- Add trackBy: trackByFn -->
        <div *ngFor="let message of project?.chatHistory?.[sheetid]; let i = index; trackBy: trackByFn"
            [ngClass]="{'user-message': message.role === 'user', 'assistant-message': message.role === 'assistant', 'chat-message-animation': true}"
            style="margin-bottom: 10px; padding: 8px; border-radius: 4px; position: relative; display: flex; flex-direction: column; align-items: flex-start;">
            <!-- Message Content Wrapper for Expand/Collapse -->
            <div class="message-content-wrapper" [ngClass]="{'collapsed-message': !message.expanded && getMessageLineCount(message.content) > 5}"
                (click)="getMessageLineCount(message.content) > 5 && (message.expanded = !message.expanded)" [style.cursor]="getMessageLineCount(message.content) > 5 ? 'pointer' : 'default'" style="width: 100%;">
                <div class="message-content" style="word-wrap: break-word; white-space: pre-wrap; max-width: 100%; flex-grow: 1;">
                    {{ message.content }}
                </div>
                <!-- Overlay for collapsed message - Conditionally show -->
                <div *ngIf="!message.expanded && getMessageLineCount(message.content) > 5" class="expand-overlay" (click)="$event.stopPropagation(); message.expanded = true;">
                    <span>...</span>
                </div>
            </div>
            <!-- Message Actions (for assistant messages) -->
            <div class="message-actions" style="margin-top: 5px; align-self: flex-end;">
                <button *ngIf="message.role === 'assistant'" mat-icon-button matTooltip="Set current sheet to this response" (click)="copyAssistantResponseToSheet(message.content, i)"
                    style="min-width: 32px; padding: 0 6px; height: 24px; line-height: 24px;" [ngClass]="{'animated-success-button': shouldShowSetAnimation(i)}">
                    <i class="fa-solid fa-xs" [ngClass]="{'fa-copy': !shouldShowSetAnimation(i), 'fa-check': shouldShowSetAnimation(i)}"></i>
                </button>
                <!-- <button *ngIf="message.role === 'assistant'" mat-icon-button matTooltip="Show Diff" (click)="toggleDiff(i)" style="min-width: 32px; padding: 0 6px; height: 24px; line-height: 24px;">
                    <i class="fa-solid fa-xs fa-code-compare"></i>
                </button> -->
                <button *ngIf="message.role === 'assistant'" mat-icon-button matTooltip="Copy to prompt and submit" (click)="copyToPromptAndSubmit(message.content)"
                    style="min-width: 32px; padding: 0 6px; height: 24px; line-height: 24px;">
                    <i class="fa-solid fa-xs fa-paper-plane"></i>
                </button>
            </div>
            <!-- Diff View -->
            <div *ngIf="showDiff && diffIndex === i" class="diff-view" [innerHTML]="getDiffHtml(i)"
                style="margin-top: 10px; padding: 10px; background-color: #f0f0f0; border: 1px solid #ccc; border-radius: 4px; width: 100%; font-family: monospace; white-space: pre-wrap; max-height: 300px; overflow: auto;">
            </div>
        </div>

        <!-- Loading indicator for AI response -->
        <div *ngIf="project?.sheetStates?.[sheetid]?.isProcessingResponse" class="assistant-message loading-message" style="margin-bottom: 10px; padding: 8px; border-radius: 4px; display: flex; align-items: center;">
            <mat-spinner diameter="20" style="margin-right: 8px;"></mat-spinner>
            <span>{{ project?.sheetStates?.[sheetid]?.loadingText || 'Processing...' }}</span>
        </div>

        <!-- Loading indicator for checking image -->
        <div *ngIf="project?.sheetStates?.[sheetid]?.isCheckingImage" class="assistant-message loading-message" style="margin-bottom: 10px; padding: 8px; border-radius: 4px; display: flex; align-items: center;">
            <mat-spinner diameter="20" style="margin-right: 8px;"></mat-spinner>
            <span>Checking image...</span>
        </div>

        <!-- Loading indicator for analyzing model -->
        <!-- <div *ngIf="project?.sheetStates?.[sheetid]?.isAnalyzingModel" class="assistant-message loading-message" style="margin-bottom: 10px; padding: 8px; border-radius: 4px; display: flex; align-items: center;">
            <mat-spinner diameter="20" style="margin-right: 8px;"></mat-spinner>
            <span>Analyzing model...</span>
        </div> -->
    </div>

    <!-- Prompt Input Section -->
    <div class="prompt-container" style="background: #434343; padding: 6px 9px; border-radius: 9px; position: relative;">
        <label for="context">AI Prompt:</label>

        <!-- Example Prompts Section -->
        <div class="example-prompts" style="margin-bottom: 10px; display: flex; flex-wrap: wrap; gap: 5px; align-items: center; position: relative;">
            <span *ngFor="let example of examplePrompts" class="example-prompt-tag" (click)="selectExamplePrompt(example.prompt)" [matTooltip]="example.description">
                {{ example.label }}
            </span>

            <!-- Prompt Library Menu Icon -->
            <div class="prompt-library-menu">
                <button mat-icon-button class="prompt-library-menu-button" (click)="$event.stopPropagation(); togglePromptLibraryMenu()" matTooltip="Browse more prompts from library" style="margin-left: 10px;">
                    <i class="fa-solid fa-bars" style="color: white;"></i>
                </button>

                <!-- Prompt Library Dropdown Menu -->
                <div *ngIf="showPromptLibraryMenu" class="prompt-library-dropdown">
                    <!-- Main Categories View -->
                    <div *ngIf="!selectedCategory" class="library-categories">
                        <div class="library-header">
                            <h4>Prompt Library</h4>
                            <button mat-icon-button (click)="$event.stopPropagation(); togglePromptLibraryMenu()">
                                <i class="fa-solid fa-times"></i>
                            </button>
                        </div>
                        <div class="categories-grid">
                            <div *ngFor="let category of promptLibraryCategories" class="category-item" (click)="$event.stopPropagation(); selectCategory(category)">
                                <div class="category-title">{{ category.name }}</div>
                                <div class="category-description">{{ category.description }}</div>
                                <div class="category-count">
                                    {{ (category.subcategories?.length || 0) + (category.prompts?.length || 0) }} items
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Subcategories View -->
                    <div *ngIf="selectedCategory && !selectedSubcategory" class="library-subcategories">
                        <div class="library-header">
                            <button mat-icon-button (click)="$event.stopPropagation(); goBackToCategories()">
                                <i class="fa-solid fa-arrow-left"></i>
                            </button>
                            <h4>{{ selectedCategory.name }}</h4>
                            <button mat-icon-button (click)="$event.stopPropagation(); togglePromptLibraryMenu()">
                                <i class="fa-solid fa-times"></i>
                            </button>
                        </div>

                        <!-- Show subcategories if they exist -->
                        <div *ngIf="selectedCategory.subcategories && selectedCategory.subcategories.length > 0" class="subcategories-grid">
                            <div *ngFor="let subcategory of selectedCategory.subcategories" class="subcategory-item" (click)="$event.stopPropagation(); selectSubcategory(subcategory)">
                                <div class="subcategory-title">{{ subcategory.name }}</div>
                                <div class="subcategory-description">{{ subcategory.description }}</div>
                                <div class="subcategory-count">{{ subcategory.prompts?.length || 0 }} prompts</div>
                            </div>
                        </div>

                        <!-- Show direct prompts if no subcategories -->
                        <div *ngIf="selectedCategory.prompts && selectedCategory.prompts.length > 0" class="prompts-list">
                            <div *ngFor="let prompt of selectedCategory.prompts" class="prompt-item" (click)="$event.stopPropagation(); selectLibraryPrompt(prompt)">
                                <div class="prompt-name">{{ prompt.name }}</div>
                                <div class="prompt-preview">{{ prompt.prompt.length > 100 ? prompt.prompt.substring(0, 100) + '...' : prompt.prompt }}</div>
                            </div>
                        </div>
                    </div>

                    <!-- Prompts View -->
                    <div *ngIf="selectedSubcategory" class="library-prompts">
                        <div class="library-header">
                            <button mat-icon-button (click)="$event.stopPropagation(); goBackToSubcategories()">
                                <i class="fa-solid fa-arrow-left"></i>
                            </button>
                            <h4>{{ selectedSubcategory.name }}</h4>
                            <button mat-icon-button (click)="$event.stopPropagation(); togglePromptLibraryMenu()">
                                <i class="fa-solid fa-times"></i>
                            </button>
                        </div>
                        <div class="prompts-list">
                            <div *ngFor="let prompt of selectedSubcategory.prompts" class="prompt-item" (click)="$event.stopPropagation(); selectLibraryPrompt(prompt)">
                                <div class="prompt-name">{{ prompt.name }}</div>
                                <div class="prompt-preview">{{ prompt.prompt.length > 100 ? prompt.prompt.substring(0, 100) + '...' : prompt.prompt }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style="display: flex; align-items: flex-end;">
            <textarea #promptTextarea id="context" style="flex: 1 1 auto; width: 100%; resize: vertical; min-height: 80px;max-height: 200px;" [(ngModel)]="aiPrompt" (input)="adjustTextareaHeight($event)"
                (keydown)="handleKeyDown($event)" name="context" placeholder="Type your prompt here... Press Ctrl+Enter (or Cmd+Enter on Mac) to submit"></textarea>
            <button id="improvePromptButton" mat-mini-fab style="position: absolute; bottom: 5px; right: 5px;" color="primary" (click)="$event.preventDefault(); getPrompt(aiPrompt)" matTooltip="AI Wizard"
                [disabled]="isImprovingPrompt">
                <i class="fas" [ngClass]="{'fa-magic': !isImprovingPrompt, 'fa-spinner fa-spin': isImprovingPrompt}"></i>
            </button>
        </div>
        <!-- AI Provider Selection -->
        <div *ngIf="isLocalhost" style="display: flex; justify-content: flex-start; margin-top: 5px;">
            <mat-form-field appearance="fill" style="width: 220px; margin-right: 10px;">
                <mat-label>AI Provider</mat-label>
                <mat-select [(ngModel)]="aiProvider">
                    <!-- <mat-option value="gemini-pro-preview-03-25">Gemini Pro Preview</mat-option> -->
                    <mat-option value="gemini-2.5-flash">Gemini Flash Preview</mat-option>
                    <mat-option value="gemini-2.5-flash-lite-preview-06-17">Gemini Flash Lite Preview</mat-option>
                    <mat-option value="gemini-2.5-pro">Gemini 2.5 Pro Preview</mat-option>
                    <mat-option value="claude">Claude</mat-option>
                    <mat-option value="gpt-4o">gpt-4o</mat-option>
                    <mat-option value="gpt-4.1">gpt-4.1</mat-option>
                    <mat-option value="o3">o3</mat-option>
                    <mat-option value="o4-mini">o4-mini</mat-option>
                    <!-- <mat-option value="o4-mini-high">o4-mini-high</mat-option> -->
                    <mat-option value="deepseek">DeepSeek</mat-option>
                    <mat-option value="xai-grok-beta">Grok Beta</mat-option>
                </mat-select>
            </mat-form-field>
            <div style="display: flex; align-items: center; margin-right: 10px;">
                <span style="font-size: 14px; color: white;">Credits: {{ userCredits }}</span>
            </div>
            <!-- Gemini Thinking Toggle -->
            <div *ngIf="aiProvider === 'gemini-2.5-flash' || aiProvider === 'gemini-2.5-flash-lite-preview-06-17' || aiProvider === 'gemini-2.5-pro'" class="thinking-toggle">
                <mat-checkbox [(ngModel)]="geminiThinkingEnabled" color="primary">
                    Enable Thinking
                </mat-checkbox>
            </div>
            <!-- <mat-form-field appearance="fill" style="width: 100px;">
                <mat-label>Temp</mat-label>
                <input matInput type="number" [(ngModel)]="temperature" step="0.1" min="0" max="1">
            </mat-form-field> -->
        </div>
    </div>

    <!-- Bottom Controls Section -->
    <div class="bottom-controls" style="padding:5px; width: 100%; overflow: hidden;">
        <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin-bottom: 10px;">
            <!-- Add Attachments Section -->
            <div class="attachment-section">
                <button mat-raised-button color="primary" [matMenuTriggerFor]="attachmentMenu">
                    <i class="fa-solid fa-paperclip"></i>
                </button>
                <mat-menu #attachmentMenu="matMenu">
                    <button mat-menu-item (click)="addTableMarking('formulas')">Attach Selected Formulas</button>
                    <button mat-menu-item (click)="addTableMarking('values')">Attach Selected Values</button>
                    <button mat-menu-item (click)="addScreenshot('model')">Attach 3D View Screenshot</button>
                    <button mat-menu-item (click)="addMultiViewScreenshots()">Attach Multi-View Screenshots</button>
                    <button mat-menu-item (click)="addImage()">Attach Image from File</button>
                    <button mat-menu-item (click)="openDrawingCanvas()">Attach Drawing</button>
                    <button mat-menu-item (click)="addDocument()">Attach PDF/TXT Document</button>
                </mat-menu>
                <!-- Display Added Attachments -->
                <div class="attachments-display" style="margin-top: 5px; display: flex; flex-wrap: wrap; gap: 5px;">
                    <!-- Loop through component's attachments -->
                    <span *ngFor="let attachment of attachments; let i = index" class="badge bg-secondary me-2 mb-2 mr-1">
                        {{ getAttachmentDisplay(attachment) }}
                        <!-- Optional thumbnail popup for image attachments -->
                        <span class="image-popup-container" *ngIf="attachment.type === 'image' || attachment.isScreenshot || attachment.markingType === 'uploaded'">
                            <img class="thumbnail" [src]="attachment.data" alt="Attachment thumbnail" style="height: 20px; margin-left: 5px; cursor: pointer;" />
                            <img class="popup-image" [src]="attachment.data" alt="Attachment full size">
                        </span>
                        <!-- Icon for document attachments -->
                        <span *ngIf="attachment.type === 'document'" class="document-icon" style="margin-left: 5px;">
                            <i class="fas" [ngClass]="{'fa-file-pdf': attachment.fileType === 'pdf', 'fa-file-alt': attachment.fileType === 'txt'}"></i>
                        </span>
                        <button mat-icon-button (click)="removeScreenshot(i)" style="height: 16px; width: 16px; line-height: 16px; margin-left: 4px;">
                            <i class="fas fa-times" style="font-size: 10px;"></i>
                        </button>
                    </span>
                </div>
            </div>

            <!-- Agent Mode Checkbox -->
            <div class="agent-mode-section">
                <mat-checkbox [(ngModel)]="agentMode" color="primary">
                    <!-- <i class="fa-solid fa-robot" style="margin-right: 5px;"></i> -->
                    Agent Mode
                </mat-checkbox>
            </div>

            <!-- Model Interaction Buttons -->
            <div class="model-interaction-section">
                <button id="checkImageButton" mat-raised-button (click)="testCheckImageContent()" color="primary" [disabled]="project?.sheetStates?.[sheetid]?.isCheckingImage"
                    [ngClass]="{'animated-check-button': animatedCheckButtonActive}">
                    <i class="fa-solid" [ngClass]="project?.sheetStates?.[sheetid]?.isCheckingImage ? 'fa-stop' : 'fa-eye'"></i>
                    <!-- {{ project?.sheetStates?.[sheetid]?.isCheckingImage ? 'Stop' : 'Check' }} -->
                </button>
                <button id="generateSubProjectsButton" mat-raised-button (click)="generateSubProjects()" color="primary" [disabled]="project?.sheetStates?.[sheetid]?.isGeneratingSubProjects || !aiPrompt?.trim()"
                    matTooltip="Break down the current prompt into sub-projects">
                    <i class="fa-solid" [ngClass]="project?.sheetStates?.[sheetid]?.isGeneratingSubProjects ? 'fa-spinner fa-spin' : 'fa-project-diagram'"></i>
                    <!-- {{ project?.sheetStates?.[sheetid]?.isGeneratingSubProjects ? 'Working...' : 'Breakdown' }} -->
                </button>
                <!-- <button mat-raised-button (click)="analyzeModel()" [disabled]="project?.sheetStates?.[sheetid]?.isAnalyzingModel" matTooltip="Ask AI to analyze the structure and properties of the current 3D model">
                    <i class="fa-solid" [ngClass]="project?.sheetStates?.[sheetid]?.isAnalyzingModel ? 'fa-stop' : 'fa-magnifying-glass-chart'"></i>
                    {{ project?.sheetStates?.[sheetid]?.isAnalyzingModel ? 'Stop Analyzing' : 'Analyze Model' }}
                </button> -->
            </div>

            <!-- Submit Button -->
            <div class="submit-section">
                <button mat-raised-button [color]="project?.sheetStates?.[sheetid]?.isSubmitting ? 'warn' : 'primary'" (click)="handlePrimaryAction()"
                    [disabled]="!project?.sheetStates?.[sheetid]?.isSubmitting && !aiPrompt?.trim()" [ngClass]="{'stop-button-active': project?.sheetStates?.[sheetid]?.isSubmitting}" style="min-width: 100px;">
                    <div *ngIf="!project?.sheetStates?.[sheetid]?.isSubmitting" style="display: flex; align-items: center;">
                        <i class="fa-solid fa-paper-plane" style="margin-right: 5px;"></i>
                        Submit
                    </div>
                    <!-- Show stop text/icon only when submitting -->
                    <div *ngIf="project?.sheetStates?.[sheetid]?.isSubmitting" style="display: flex; align-items: center;">
                        <i class="fa-solid fa-stop" style="margin-right: 5px;"></i>
                        Stop
                    </div>
                </button>

                <!-- 5x Button -->
                <button mat-raised-button color="accent" (click)="submit5x()" [disabled]="isAnySheetSubmitting() || !aiPrompt?.trim()" matTooltip="Run the same query on all sheets"
                    style="min-width: 60px; margin-left: 10px;">
                    <div style="display: flex; align-items: center;">
                        <i class="fa-solid fa-layer-group" style="margin-right: 5px;"></i>
                        5x
                    </div>
                </button>
            </div>

        </div>

    </div>

    <!-- Add styles for diff view -->
    <style>
        /* Tab processing indicator styles */
        .tab-label-container {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .processing-tab {
            position: relative;
        }

        .processing-indicator {
            font-size: 12px;
            color: #4caf50;
            animation: pulse 1.5s infinite;
        }

        @keyframes pulse {
            0% {
                opacity: 0.5;
            }

            50% {
                opacity: 1;
            }

            100% {
                opacity: 0.5;
            }
        }

        /* Diff view styles */
        .diff-line {
            padding: 2px 5px;
            margin: 1px 0;
            font-family: monospace;
            white-space: pre-wrap;
            word-break: break-all;
        }

        .diff-line.unchanged {
            color: #333;
            background-color: #f8f8f8;
        }

        .diff-line.added {
            color: #22863a;
            background-color: #e6ffed;
        }

        .diff-line.removed {
            color: #cb2431;
            background-color: #ffeef0;
        }

        .active {
            color: #673ab7;
        }

        .no-changes {
            color: #666;
            font-style: italic;
            padding: 10px;
            text-align: center;
        }

        /* Character-level diff highlights */
        .highlight-removed {
            background-color: #ff8080;
            color: #660000;
            text-decoration: line-through;
            padding: 0 2px;
            border-radius: 2px;
            font-weight: bold;
        }

        .highlight-added {
            background-color: #80ff80;
            color: #006600;
            padding: 0 2px;
            border-radius: 2px;
            font-weight: bold;
        }

        /* Styles for attachments */
        .attachments-display .badge {
            display: flex;
            align-items: center;
            padding: 0.3em 0.6em;
        }

        .attachments-display .btn-close {
            padding: 0;
            margin-left: 0.5em;
            background: none;
            border: none;
            color: white;
            opacity: 0.7;
            cursor: pointer;
        }

        .attachments-display .btn-close:hover {
            opacity: 1;
        }

        /* Styles for image popup */
        .image-popup-container {
            position: relative;
            display: inline-block;
            /* Changed from flex for inline display */
            margin-left: 5px;
        }

        .thumbnail {
            height: 20px;
            cursor: pointer;
            vertical-align: middle;
            /* Align thumbnail with text */
        }

        .popup-image {
            display: none;
            position: absolute;
            bottom: 100%;
            /* Position above the thumbnail */
            left: 50%;
            transform: translateX(-50%);
            border: 1px solid #ccc;
            background-color: white;
            padding: 5px;
            z-index: 100;
            max-width: 300px;
            max-height: 300px;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        }

        .image-popup-container:hover .popup-image {
            display: block;
        }

        /* Animated success button */
        .animated-success-button {
            transition: background-color 0.3s ease, color 0.3s ease;
            background-color: #4CAF50 !important;
            /* Green background */
            color: white !important;
        }

        .button-text-animated {
            /* Add animation if needed, e.g., fade out/in */
        }

        /* Collapsed message */
        .collapsed-message {
            max-height: 100px;
            /* Adjust as needed */
            overflow: hidden;
            position: relative;
            cursor: pointer;
        }

        .expand-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 30px;
            /* Height of the fade-out area */
            background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 90%);
            display: flex;
            justify-content: center;
            align-items: flex-end;
            padding-bottom: 5px;
            color: #007bff;
            font-weight: bold;
        }

        .expand-overlay span {
            background-color: rgba(255, 255, 255, 0.8);
            padding: 0 5px;
            border-radius: 3px;
        }

        /* Animated check button */
        .animated-check-button {
            animation: pulse-border 1.5s infinite;
        }

        @keyframes pulse-border {
            0% {
                box-shadow: 0 0 0 0 rgba(63, 81, 181, 0.4);
                /* Adjust color as needed */
            }

            70% {
                box-shadow: 0 0 0 10px rgba(63, 81, 181, 0);
            }

            100% {
                box-shadow: 0 0 0 0 rgba(63, 81, 181, 0);
            }
        }

        /* Document icon styles */
        .document-icon {
            display: inline-flex;
            align-items: center;
            font-size: 16px;
            color: #fff;
        }

        .drawing-dialog {
            display: flex;
            flex-direction: column;
            /* Make dialog wider using viewport width */
            width: 85vw;
            /* Set to 85% of viewport width */
            /* Remove max-width or adjust if needed */
            /* max-width: 95vw; */
        }

        .canvas-container {
            border: 1px solid #ccc;
            margin-bottom: 10px;
            touch-action: none;
            /* Make canvas container fill the dialog width */
            width: 100%;
            /* Fills the .drawing-dialog */
            /* Keep height fixed or adjust as needed */
            height: 600px;
        }

        /* Example prompt tags styles */
        .example-prompt-tag {
            display: inline-block;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 6px 12px;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
            border: none;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            user-select: none;
        }

        .example-prompt-tag:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
        }

        .example-prompt-tag:active {
            transform: translateY(0);
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        /* Prompt Library Menu Styles */
        .prompt-library-menu {
            position: relative;
            display: inline-block;
        }

        .prompt-library-menu-button {
            background: rgba(255, 255, 255, 0.1) !important;
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 50%;
            width: 32px;
            height: 32px;
            min-height: 32px;
            line-height: 32px;
        }

        .prompt-library-menu-button:hover {
            background: rgba(255, 255, 255, 0.2) !important;
        }

        .prompt-library-dropdown {
            position: fixed;
            top: auto;
            left: auto;
            right: auto;
            bottom: auto;
            background: white;
            border: 1px solid #ddd;
            border-radius: 8px;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
            z-index: 99999;
            max-height: 400px;
            overflow-y: auto;
            min-width: 500px;
            max-width: 600px;
        }

        .library-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 16px;
            border-bottom: 1px solid #eee;
            background: #f8f9fa;
            border-radius: 8px 8px 0 0;
        }

        .library-header h4 {
            margin: 0;
            color: #333;
            font-size: 16px;
            font-weight: 600;
        }

        .categories-grid,
        .subcategories-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            gap: 8px;
            padding: 12px;
        }

        .category-item,
        .subcategory-item {
            padding: 12px;
            border: 1px solid #e0e0e0;
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.2s ease;
            background: white;
        }

        .category-item:hover,
        .subcategory-item:hover {
            border-color: #667eea;
            box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
            transform: translateY(-1px);
        }

        .category-title,
        .subcategory-title {
            font-weight: 600;
            color: #333;
            margin-bottom: 4px;
            font-size: 14px;
        }

        .category-description,
        .subcategory-description {
            color: #666;
            font-size: 12px;
            margin-bottom: 6px;
            line-height: 1.3;
        }

        .category-count,
        .subcategory-count {
            color: #888;
            font-size: 11px;
            font-weight: 500;
        }

        .prompts-list {
            max-height: 300px;
            overflow-y: auto;
            padding: 8px;
        }

        .prompt-item {
            padding: 10px 12px;
            border: 1px solid #e0e0e0;
            border-radius: 6px;
            margin-bottom: 6px;
            cursor: pointer;
            transition: all 0.2s ease;
            background: white;
        }

        .prompt-item:hover {
            border-color: #667eea;
            box-shadow: 0 2px 6px rgba(102, 126, 234, 0.1);
            background: #f8f9ff;
        }

        .prompt-item:last-child {
            margin-bottom: 0;
        }

        .prompt-name {
            font-weight: 600;
            color: #333;
            margin-bottom: 4px;
            font-size: 13px;
        }

        .prompt-preview {
            color: #666;
            font-size: 11px;
            line-height: 1.4;
            max-height: 40px;
            overflow: hidden;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {

            .categories-grid,
            .subcategories-grid {
                grid-template-columns: 1fr;
            }

            .prompt-library-dropdown {
                max-height: 300px;
            }
        }
    </style>